module.exports = __webpack_public_path__ + "img/wondergreen.bf0a2910.png";